import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private toast: ToastrService) {}

  showToast(
    message: string,
    type: 'success' | 'error' | 'warning' | 'info'
  ): void {
    switch (type) {
      case 'success':
        this.toast.success(message);
        break;
      case 'error':
        this.toast.error(message);
        break;
      case 'warning':
        this.toast.warning(message);
        break;
      case 'info':
        this.toast.info(message);
        break;
      default:
        this.toast.info(message);
    }
  }
}
